import { Divider, Paper, Stack, Typography } from '@mui/material';
import { Card, Gallery } from 'components';
import { isNoPreviewByOriginalFileName } from 'utils';
import React, { useState } from 'react';
import { useCampaign } from 'hooks';
import { CreativePreview } from 'components/CampaignCard/CreativePreview';

export const OverviewCreatives: React.FC = () => {
  const { getCampaignQuery } = useCampaign();

  const [isGalleryOpen, setIsGalleryOpen] = useState<null | number>(null);
  const [galleryCreativeIndex, setGalleryCreativeIndex] = useState(0);
  const campaign = getCampaignQuery.data?.campaign;

  const openGallery = (creativeIndex: number, websiteIndex: number) => {
    setGalleryCreativeIndex(creativeIndex);
    setIsGalleryOpen(websiteIndex);
  };

  const websitesWithData = campaign?.websites.map((site) => {
    return {
      ...site,
      creatives: campaign.creatives.filter((creative) => creative.websiteId === site.id),
    };
  });

  return (
    <>
      <Typography variant="h2" mt={5} mb={5}>
        Creatives
      </Typography>
      {websitesWithData?.map(({ url, id, creatives }) => (
        <Card
          sx={{
            flex: 1,
          }}
          key={id}
        >
          <Stack gap={6}>
            <Typography variant="h3" sx={{ wordBreak: 'break-word' }}>
              {url}
            </Typography>
            <Divider />
            <Stack direction="row" gap={5} flexWrap={'wrap'}>
              {creatives.length
                ? creatives.map((creative, index) => {
                    return (
                      <Stack key={creative.id}>
                        <Paper
                          onClick={() => openGallery(index, id)}
                          sx={(theme) => ({
                            width: theme.spacing(30),
                            height: theme.spacing(30),
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer',
                          })}
                        >
                          <CreativePreview creative={creative} />
                        </Paper>
                        <Typography mt={2} variant="body3" align={'center'}>
                          {creative.creativeType?.displayName} <br />
                          {creative.creativeType?.width}x{creative.creativeType?.height}
                        </Typography>
                      </Stack>
                    );
                  })
                : 'no creatives added'}
              <Gallery
                url={url}
                isOpened={isGalleryOpen === id}
                creativesOverview={creatives.map((creative) => ({
                  ...creative,
                  isPreviewInvalid:
                    !!creative.originalFileName && isNoPreviewByOriginalFileName(creative.originalFileName),
                }))}
                selectedCreative={galleryCreativeIndex}
                onClose={() => setIsGalleryOpen(null)}
                onNext={() => setGalleryCreativeIndex((prev) => (prev === creatives.length - 1 ? 0 : prev + 1))}
                onPrev={() => setGalleryCreativeIndex((prev) => (prev === 0 ? creatives.length - 1 : prev - 1))}
              />
            </Stack>
          </Stack>
        </Card>
      ))}
    </>
  );
};
